import React, { useEffect, useMemo, useState } from "react";
import { Dialog, DialogContent, DialogTitle, LinearProgress, ListItem } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import { mkConfig, generateCsv, download } from 'export-to-csv'
import ReactDOM from 'react-dom/client';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import { Box, Button } from "@mui/material";
import { Grid } from "@mui/material";
import { showNotificationDialogEmergencyOrder } from "redux/actions/notificationEmergencyOrderActions"
import { useDispatch,useSelector } from "react-redux";
import { SOMS_API_KEY } from "services/CONSTANTS";
import { resetUploadEmergencyError, uploadEmergencyOrderFile } from "redux/actions/emergencyOrderUploadAction"
import ReasonCodesPopup from "./ReasonCodesPopup";
import { showErrorMessageByCode } from "services/commonServices";
import { showNotificationDialog } from "redux/actions/notificationActions";
import { Provider } from "react-redux";
import { store as reduxStore, persistor } from "redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { encryptString } from "components/common/EncryptDecrypt";

export const Validate = () => {
  const dispatch = useDispatch();
  const [getData, setGetData] = useState([]);
  const [getNewData, setGetNewData] = useState([]);
  const [emergencyOrderState, setEmergencyOrderState] = useState([]);
  const [isErrorPopupFlag, setIsErrorPopupFlag] = useState(true);
  const [showFileUploadPopup, setShowFileUploadPopup] = useState(false);
   const [invokeFlag, setInvokeFlag] = useState(false);
  const userType = useSelector((state) => state.user);
  const loginResponse = userType.loginResponse;

  let {emergencyorderUploadResponse , emergencyorderUploadResMetaData,isuploadEmergencyOrderSuccess ,isuploadEmergencyOrderError} = useSelector((state) => (
   {
    emergencyorderUploadResponse: state.uploadEmergencyOrderFile.uploadEmergencyOrderResponse.emergencyOrders,
    emergencyorderUploadResMetaData: state.uploadEmergencyOrderFile.uploadEmergencyOrderResponse.metadata ,
    isuploadEmergencyOrderSuccess:state.uploadEmergencyOrderFile.isuploadEmergencyOrderSuccess,
    isuploadEmergencyOrderError:state.uploadEmergencyOrderFile.isuploadEmergencyOrderError
   } 
  ));
  let arrOfObjectWithId = emergencyOrderState.map((obj, index) => ({
            ...obj,
            id: index + 1
        }));
        
     let uploadedEmergencyOrderResponse = JSON.stringify(arrOfObjectWithId);

  function formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }
  let todayOrderDate = formatDate(Date())

  let currentOrderDate = todayOrderDate.replace(/-/g, '');
  let dataForUpload;

  useMemo(() => {
    if (uploadedEmergencyOrderResponse) {
      
      setGetData(JSON.parse(uploadedEmergencyOrderResponse));
      setGetNewData(JSON.parse(uploadedEmergencyOrderResponse));
    }

  }, [uploadedEmergencyOrderResponse])


  useEffect(() => {
    let errorList;
    let multipleErrorsMsg
      if(emergencyorderUploadResMetaData?.failure !== 0){
          errorList = [`Total number of line items = ${emergencyorderUploadResMetaData?.count}`, `Emergency order created for line items = ${emergencyorderUploadResMetaData?.success}`, `Emergency order validation failed line items = ${emergencyorderUploadResMetaData?.failure}`]     
      } else  {
       errorList = [`Total number of line items = ${emergencyorderUploadResMetaData?.count}`, `Emergency order created for line items = ${emergencyorderUploadResMetaData?.success}`]
      } 
      let errorListItems = errorList?.map((x, index) => <ListItem dense sx={{ p: 0, display: 'list-item' }} key={index}>{`${x}`}</ListItem>)
      if(invokeFlag){
         multipleErrorsMsg = (
          <>
            <Typography variant="span">Emergency orders submitted with some validation failed line items, refer to the table below for the exact status: </Typography>
            <List dense sx={{ listStyleType: 'disc' }}>{errorListItems}</List>
          </>
        );
      } else{
        multipleErrorsMsg = (
          <>
            <Typography variant="span">Emergency orders file uploaded with some validation failed line items, refer to the table below for the exact status: </Typography>
            <List dense sx={{ listStyleType: 'disc' }}>{errorListItems}</List>
          </>
        );
      }
      

if(isuploadEmergencyOrderSuccess){
  dispatch(
    showNotificationDialogEmergencyOrder(
      "Upload Status",
       multipleErrorsMsg,
      'Done'
    )
  );
  dispatch(resetUploadEmergencyError());
  setShowFileUploadPopup(false);
}
if(isuploadEmergencyOrderSuccess && invokeFlag){
  dispatch(
    showNotificationDialogEmergencyOrder(
      "Submit Status",
       multipleErrorsMsg,
      'Done'
    )
  );
  setInvokeFlag(false);
  dispatch(resetUploadEmergencyError());
  setShowFileUploadPopup(false);
}
if(isuploadEmergencyOrderSuccess && emergencyorderUploadResMetaData.failure === 0){
  dispatch(
    showNotificationDialogEmergencyOrder(
      "Submitted Successfully",
       multipleErrorsMsg,
      'Done'
    )
  );
  dispatch(resetUploadEmergencyError());
  setShowFileUploadPopup(false);
}

if (isuploadEmergencyOrderError && isErrorPopupFlag) {
  setShowFileUploadPopup(false);
  const { errTitle, errContent } = showErrorMessageByCode(emergencyorderUploadResponse);

  dispatch(showNotificationDialog(errTitle, errContent, 'Done'));
  setShowFileUploadPopup(false);
  setIsErrorPopupFlag(false);
  dispatch(resetUploadEmergencyError());
}

  }, [dispatch,isuploadEmergencyOrderSuccess,emergencyorderUploadResMetaData,emergencyorderUploadResponse,isuploadEmergencyOrderError,isErrorPopupFlag,invokeFlag])
  const columns = useMemo(

    () =>
      [
        {
          accessorKey: 'id',
          header: 'ID',
          enableEditing: false,
          size: 100,         
        },
        {
          accessorKey: 'orderDate',
          header: 'Order Date',
          enableEditing: false,
          type: Date,
          size: 100,
          
          Cell: ({ cell }) => {
            return <div>{currentOrderDate}</div>

          }
        },
        {
          accessorKey: 'min',
          header: 'Min',

          size: 120,
          required: true,
          muiEditTextFieldProps: ({ row, cell }) => ({
            disabled: row.original.minValidation === true, 
            type: 'number',         
          }),
          Cell: ({ cell }) => {
            if (cell.row.original.minValidation === false && cell.row.original.min !== cell.row._valuesCache.min)
              return <div>
                {cell.getValue()}
              </div>
            else if (cell.row.original.minValidation === false) {
              return <div>
                <Box sx={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  height: "25px",
                  width: "120px",
                  outline: '1px solid red',
                  textAlign: 'left',
                }}>
                  <span>{cell.getValue()}</span>
                  <Tooltip title={cell.row.original.minValidationReason} >
                    <IconButton sx={{ color: 'red', marginLeft: 'auto', padding: '0' }}>
                      <ErrorOutlineIcon sx={{ fontSize: '18px' }} />
                    </IconButton>
                  </Tooltip>

                </Box>
              </div>

            }
            else
              return <div>

                {cell.getValue()} </div>



          }

          

        },
        {
          accessorKey: 'pin',
          header: 'Pin',
          enableEditing: true,
          enableClickToCopy: false,
          size: 100,

          muiEditTextFieldProps: ({ row, cell }) => ({
            disabled: row.original.pinValidation === true, 
            type: 'number',
           

          }),
          Cell: ({ cell }) => {
            if(cell.row.original.pinValidation === false && cell.row._valuesCache.pin === ""){
              return <div>
              
              <Box sx={{
                display: "flex",
                justifyContent:"left",
                alignItems: "center",
                height: "30px",
                width: "120px",
                outline: '1px solid red',
                textAlign: 'left',
              }}>
                <span>{cell.getValue()}</span>
                <Tooltip title="PIN number cannot be blank/empty, please enter correct PIN." >
                  <IconButton sx={{ color: 'red', marginLeft: 'auto', padding: '0' }}>
                    <ErrorOutlineIcon sx={{ fontSize: '18px' }} />
                  </IconButton>
                </Tooltip>

              </Box>
            </div>
            }
            if (cell.row.original.pinValidation === false && cell.row.original.pin !== cell.row._valuesCache.pin)
              return <div>
                {cell.getValue()}
              </div>

            else if (cell.row.original.pinValidation === false) {
              return <div>  
                <Box sx={{
                  display: "flex",
                  justifyContent:"left",
                  alignItems: "center",
                  height: "30px",
                  width: "120px",
                  outline: '1px solid red',
                  textAlign: 'left',
                }}>
                  <span>{cell.getValue()}</span>
                  <Tooltip title={cell.row.original.pinValidationReason} >
                    <IconButton sx={{ color: 'red', marginLeft: 'auto', padding: '0' }}>
                      <ErrorOutlineIcon sx={{ fontSize: '18px' }} />
                    </IconButton>
                  </Tooltip>

                </Box>
              </div>

            }
            else return <div>

              {cell.getValue()} </div>


          }
        

        },
        {
          accessorKey: 'fromLocation',
          header: 'From Location',
          size: 120,


          muiEditTextFieldProps: ({ row, cell }) => ({
            disabled: row.original.fromLocationValidation === true, 
            type: 'number',

          }),

          Cell: ({ cell }) => {
           if(cell.row.original.fromLocationValidation === false && cell.row._valuesCache.fromLocation === ""){
            return <div>
            <Box sx={{
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
              height: "30px",
              width: "120px",
              outline: '1px solid red',
              textAlign: 'left',
            }}>
              <span>{cell.getValue()}</span>
              <Tooltip title="From Location cannot be blank/empty, please enter correct From Location." >
                <IconButton sx={{ color: 'red', marginLeft: 'auto', padding: '0' }}>
                  <ErrorOutlineIcon sx={{ fontSize: '18px' }} />
                </IconButton>
              </Tooltip>

            </Box>
          </div>
           }
            if (cell.row.original.fromLocationValidation === false && cell.row.original.fromLocation !== cell.row._valuesCache.fromLocation)
              return <div>
                {cell.getValue()}
              </div>
            else if (cell.row.original.fromLocationValidation === false) {
              return <div>
                <Box sx={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  height: "30px",
                  width: "120px",
                  outline: '1px solid red',
                  textAlign: 'left',
                }}>
                  <span>{cell.getValue()}</span>
                  <Tooltip title={cell.row.original.fromLocationValidationReason} >
                    <IconButton sx={{ color: 'red', marginLeft: 'auto', padding: '0' }}>
                      <ErrorOutlineIcon sx={{ fontSize: '18px' }} />
                    </IconButton>
                  </Tooltip>

                </Box>
              </div>

            }
            else
              return <div>

                {cell.getValue()} </div>


          },
         
        },



        {
          accessorKey: 'toLocation',
          header: 'To Location',
          size: 80,

          muiEditTextFieldProps: ({ cell, row }) => ({

            disabled: row.original.toLocationValidation === true, 
            type: 'number',
          }),
          Cell: ({ cell }) => {
           if(cell.row.original.toLocationValidation === false && cell.row._valuesCache.toLocation === ""){
            return <div>
            <Box sx={{
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
              height: "30px",
              width: "100px",
              outline: '1px solid red',
              textAlign: 'left',
            }}>
              <span>{cell.getValue()}</span>
              <Tooltip title="To Location cannot be blank/empty, please enter correct To Location." >
                <IconButton sx={{ color: 'red', marginLeft: 'auto', padding: '0' }}>
                  <ErrorOutlineIcon sx={{ fontSize: '18px' }} />
                </IconButton>
              </Tooltip>

            </Box>
          </div>
           }
            if (cell.row.original.toLocationValidation === false && cell.row.original.toLocation !== cell.row._valuesCache.toLocation)
              return <div>
                {cell.getValue()}
              </div>
            else if (cell.row.original.toLocationValidation === false) {
              return <div>
                <Box sx={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  height: "30px",
                  width: "100px",
                  outline: '1px solid red',
                  textAlign: 'left',
                }}>
                  <span>{cell.getValue()}</span>
                  <Tooltip title={cell.row.original.toLocationValidationReason} >
                    <IconButton sx={{ color: 'red', marginLeft: 'auto', padding: '0' }}>
                      <ErrorOutlineIcon sx={{ fontSize: '18px' }} />
                    </IconButton>
                  </Tooltip>

                </Box>
              </div>

            }
            else
              return <div>

                {cell.getValue()} </div>


          },
        },
        {
          accessorKey: 'reasonCode',
          header: 'Reason Code',
          size: 240,
          muiEditTextFieldProps: ({ row, cell }) => ({
            disabled: row.original.reasonCodeValidation === true,
            type: 'number',
          }),
          Cell: ({ cell }) => {
           if(cell.row.original.reasonCodeValidation === false && cell.row._valuesCache.reasonCode === ""){
            return <div>
            <Box sx={{
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
              height: "30px",
              width: "100px",
              outline: '1px solid red',
              textAlign: 'left',
            }}>
              <span>{cell.getValue()}</span>
              <Tooltip title="Reason code cannot be blank/empty, please enter correct Reason code." >
                <IconButton sx={{ color: 'red', marginLeft: 'auto', padding: '0' }}>
                  <ErrorOutlineIcon sx={{ fontSize: '18px' }} />
                </IconButton>
              </Tooltip>

            </Box>
          </div>
           }
            if (cell.row.original.reasonCodeValidation === false && cell.row.original.reasonCode !== cell.row._valuesCache.reasonCode)
              return <div>
                {cell.getValue()}
              </div>
            else if (cell.row.original.reasonCodeValidation === false) {
              return <div>
                <Box sx={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  height: "30px",
                  width: "100px",
                  outline: '1px solid red',
                  textAlign: 'left',
                }}>
                  <span>{cell.getValue()}</span>
                  <Tooltip title={cell.row.original.reasonCodeValidationReason} >
                    <IconButton sx={{ color: 'red', marginLeft: 'auto', padding: '0' }}>
                      <ErrorOutlineIcon sx={{ fontSize: '18px' }} />
                    </IconButton>
                  </Tooltip>

                </Box>
              </div>

            }

            return <div>

              {cell.row.original.reasonCode + ' - ' + cell.row.original.reasonCodeDescription} </div>


          },
        },
        {
          accessorKey: 'quantity',
          header: 'Quantity Ordered (Cases)',
          size: 160,
          muiEditTextFieldProps: ({ row, cell }) => ({
            
            disabled: row.original.quantityValidation === true, 
             type: 'number',         
          }),
          Cell: ({ cell }) => {
            if(cell.row.original.quantityValidation === false && cell.row._valuesCache.quantity === ""){
              return <div>
              <Box sx={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
                height: "30px",
                width: "100px",
                outline: '1px solid red',
                textAlign: 'left',

              }}>
                <span>{cell.getValue()}</span>
                <Tooltip title="Quantity cannot be blank/empty, please enter correct Quantity." >
                  <IconButton sx={{ color: 'red', marginLeft: 'auto', padding: '0' }}>
                    <ErrorOutlineIcon sx={{ fontSize: '18px' }} />
                  </IconButton>
                </Tooltip>


              </Box>
            </div>
            }
            if (cell.row.original.quantityValidation === false && cell.row.original.quantity !== cell.row._valuesCache.quantity)
              return <div>
            {cell.getValue()}
          </div>

            else if (cell.row.original.quantityValidation === false) {
              return <div>
                <Box sx={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  height: "30px",
                  width: "100px",
                  outline: '1px solid red',
                  textAlign: 'left',

                }}>
                  <span>{cell.getValue()}</span>
                  <Tooltip title={cell.row.original.quantityValidationReason} >
                    <IconButton sx={{ color: 'red', marginLeft: 'auto', padding: '0' }}>
                      <ErrorOutlineIcon sx={{ fontSize: '18px' }} />
                    </IconButton>
                  </Tooltip>


                </Box>
              </div>

            }
            else
              return <div>

                {cell.getValue()} </div>


          },
        },
      ],

    [currentOrderDate],
  );

 
  
  const updateCell = (cell, value, data) => { 
   const  updatedData = getNewData.map((row) => row.id === cell.row.original.id ? { ...row,[cell.column.id]: value} : row);
    setGetNewData(updatedData);
  }


  const table = useMaterialReactTable({
    columns,
    data: getData,
    editDisplayMode: 'cell', 
    enableCellActions: false,
    enableEditing: true,
    enableGlobalFilter: false,
    enableHiding: true,
    enableSorting: false,
    enableColumnFilterModes: false,
    enableBottomToolbar: true,
    enableColumnActions: false,
    enableColumnFilters: false,
    enableTopToolbar: false,
    enablePagination: true,
     muiEditTextFieldProps: (cell) => ({
      onBlur: (event) => {
        updateCell(cell, event.target.value, getData);
      },
       inputProps: { maxLength: 10 },

       onInput: (e) => {
        
        e.target.value = e.target.value
          .replace(/[^0-9]/g, '') 
          .slice(0, 10); 
      },
     }),
     muiTableProps: {
      className: "tableStructure tableStyle labelControl innerTableStyle",
      sx: {
        borderCollapse: "collapse",
      },
    },
    muiTableBodyCellProps:(cell)=>({
      sx: {
        '&:hover': {
          border: 'none !important',
        },
      },
    }),
    muiTableBodyRowProps: (row) => ({
      sx: {
        '&:hover': {
          border: 'none !important',
          borderLeft: 'none !important',
          borderRight: 'none !important',
          borderTop: 'none !important',
          borderBottom: 'none !important',
        },
      },
    }),
    muiTableHeadProps: {
      sx: {
        '& tr': {
          backgroundColor: '#004E37',
          '& th': {
            backgroundColor: '#004E37',
            color: '#FFF',
          }
        },

      }
    },
    muiTableContainerProps: {
      sx: {
        maxHeight: '500px',
        overflowY: 'auto',

      }
    },

    getRowId: (originalRow) => originalRow.id,
    initialState: { columnVisibility: { id: false } },

  })
  
  const handleDownloadAndReadFile = () => {
    const width = 500;
    const height = 300;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    const newWindow = window.open(
      "",
      "_blank",
      `width=${width},height=${height},left=${left},top=${top}`
    );
    if (newWindow) {
      const container = newWindow.document.createElement("div");
      newWindow.document.body.appendChild(container);
      const root = ReactDOM.createRoot(container);
      root.render(
        <Provider store={reduxStore}>
          <PersistGate loading={null} persistor={persistor}>
            <ReasonCodesPopup />
          </PersistGate>
        </Provider>
      );
      newWindow.document.close();
    }
  };

  
  const csvConfig = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
    quoteStrings: false,
    useBom: true,
    showColumnHeaders: true,
    filename: 'Emergency_Order',

  });
  const submitAllData = async() => {
    setInvokeFlag(true);
      dataForUpload =  getNewData.map((items) => {
        return {MIN:items.min ===null ? "":items.min ,PIN:items.pin===null ? "":items.pin ,FromLocation:items.fromLocation ,ToLocation:items.toLocation , QuantityInCases:items.quantity , ReasonCode:items.reasonCode, EnableJustification:items.enableJustification}
    }) 
   
   

    const csv = generateCsv(csvConfig)(dataForUpload);
    const csvContent = csv;
    const blob = new Blob([csvContent], { type: 'text/csv' });
    setShowFileUploadPopup(true);
     const encryptedEmailId = await encryptString(loginResponse?.email);
     const queryParams = {
       orderType : 'emergencyOrders',
       customerId: 'wholesale',
       amendCancelReasons: 'amendReason',
       fileName: 'emergencyOrderData.csv',
     }
     const formData = new FormData();
     formData.append("file", blob);
     formData.append("userId", encryptedEmailId);
     setIsErrorPopupFlag(true);
     const request = {
       apiKey: SOMS_API_KEY,
       params: formData,
       queryParams,
     }

     dispatch(uploadEmergencyOrderFile(request));
  }

  const handleExportData = () => {
    const csvConfigNew = mkConfig({
      fieldSeparator: ',',
      decimalSeparator: '.',
      useKeysAsHeaders: true,
      quoteStrings: false,
      useBom: true,
      showColumnHeaders: true,
      filename: 'EmergencyOrder-Failed-Validations',
    });
    dataForUpload =  getNewData.map((items) => {
      
      return {MIN:items.minValidation?items.min: 'E' + items.min,
        PIN:items.pinValidation?items.pin: 'E' + items.pin ,
        FromLocation:items.fromLocationValidation?items.fromLocation: 'E' + items.fromLocation ,
        ToLocation:items.toLocationValidation?items.toLocation: 'E' + items.toLocation ,
        QuantityInCases:items.quantityValidation?items.quantity: 'E' + items.quantity , 
        ReasonCode:items.reasonCodeValidation?items.reasonCode: 'E' + items.reasonCode}
    }) 

    const csv = generateCsv(csvConfigNew)(dataForUpload);
    download(csvConfigNew)(csv);
  };

    useEffect(() => {
    if (emergencyorderUploadResponse) {
      setEmergencyOrderState(emergencyorderUploadResponse);
    }
  }, [emergencyorderUploadResponse]);

 
 
  return (
    
    <>
    {showFileUploadPopup ? (
        <Dialog open={true} maxWidth="sm" fullWidth={true}>
          <DialogTitle>Submitting Orders</DialogTitle>
          <DialogContent>
            <LinearProgress />
            <Typography>
            To ensure the successful submission, please avoid clicking the back button, leaving the page, or refreshing it during the submission process.
            </Typography>
          </DialogContent>
        </Dialog>
      ) : (
        <div></div>
      )}
    {/* <Grid sx={{ marginBottom: 3 }}><div >

    </div>
    </Grid> */}
      <div>

        <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: 2, fontWeight: 'bold' }} display="flex" justifyContent="space-between" alignItems="center"  >
          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Validation Failed Emergency Orders Line Items</Typography>
         
          <Typography><a href="#/" style={{ color: "#108810", fontWeight: 'bold', cursor: "pointer", fontSize: '12px' }} onClick={handleDownloadAndReadFile} >View Reasons</a></Typography>

        </Box>        
        <Grid>
          <MaterialReactTable
            table={table}
           
           />        
        </Grid>
       
        <Grid container item sx={{ textAlign: "left", mt: 1 }} className="errorButtons">
          <Grid item xs={1} sm={1} className="paddingTop0">
            <Button
              variant="contained"
              type="button"
              onClick={submitAllData}
              style={{height: '25px', fontSize: '12px'}}
            >
              Submit
            </Button>
          </Grid>
          <Grid item xs={6} sm={4} className="paddingTop0">
            <Button
              variant="contained"
              type="button"
              onClick={handleExportData}
              style={{height: '25px', fontSize: '12px'}}
            >
              Download Failed Emergency Orders
            </Button>
          </Grid>
          <Grid sx={{ paddingBottom: 5 }}></Grid>
         <Grid>
          </Grid>
        </Grid>
      </div></>
  );


};
